import React from "react";
import {
  getErrorMessage,
  valFileTotalSize,
  ValType,
} from "../../utils/ValidationFunctions";
import { ImageSourceSetData } from "../classes/ImageSourceSet";
import FormImageItem from "./FormImageItem";
import FormInput from "./FormInput";
import errorStyle from "./g-error.module.scss";

type Props = {
  imgItems?: Array<File | ImageSourceSetData>;
  deleteHandler: (img: File | ImageSourceSetData, index: number) => void;
  addHandler: (value: string | File | undefined, name: string) => void;
  addBtnClass: string;
  max?: number;
  supplement?: React.ReactNode;
};
const FormMultipleImages: React.FC<Props> = ({
  imgItems,
  deleteHandler,
  addHandler,
  addBtnClass,
  max = 5,
  supplement,
}) => {
  return (
    <>
      {imgItems
        ? imgItems.map((img, i) => (
            <FormImageItem
              key={i}
              img={img instanceof File ? img : img.thumbnail?.url}
              i={i}
              deleteImg={() => {
                deleteHandler(img, i);
              }}
            />
          ))
        : null}
      {valFileTotalSize(imgItems ? imgItems : []) ? (
        <>
          {imgItems == undefined || imgItems.length < max ? (
            <>
              <button type="button" className={addBtnClass}>
                <FormInput
                  type="file"
                  label="画像を追加"
                  id="imgs"
                  name="sonic_imgs"
                  handler={addHandler}
                  val_type={ValType.File}
                />
              </button>
              {supplement ? supplement : null}
            </>
          ) : null}
        </>
      ) : (
        <>
          {supplement ? supplement : null}
          <div className={errorStyle["g-error__validation__text"]}>
            {getErrorMessage(ValType.FileTotalSize)}
          </div>
        </>
      )}
    </>
  );
};

export default FormMultipleImages;
